<template>
  <div>
    <ion-header>
      <ion-toolbar>
        <ion-buttons v-show="!showTitleOnly" slot="start">
          <ion-buttons v-show="showDoneFlag" slot="start">
            <ion-button size="small" @click="menuClick('DONE')">&lt;{{ doneString }}</ion-button>
          </ion-buttons>
          <ion-button  v-show="!showDoneFlag" size="large" @click="menuClick('PROGRAMS')">
            <ion-icon :icon="menuOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>{{ props.name }}</ion-title>
        <ion-buttons v-show="!showTitleOnly && !showDoneFlag" slot="end">
          <ion-button size="large" @click="menuClick('YOU')">{{ (!props.showSignin) ? "" : t("Signin") }}
            <span v-if="!props.showSignin">
            <ion-icon :icon="personOutline"></ion-icon>
          </span>
          </ion-button>
          <!-- <ion-button> End </ion-button> -->
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
  </div>
</template>

<script setup >

import { IonIcon,IonButton, IonButtons, IonContent, IonHeader, IonMenu, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/vue';
import { menuOutline,personOutline } from 'ionicons/icons';
import { t } from '@/composables/translateText.js'
import { computed } from "@vue/reactivity"

import { ref, onMounted, onBeforeUnmount, watch } from 'vue'

const emit = defineEmits(['menu-click'])

const props = defineProps({
  showSignin : {
    type : Boolean,
    default : false
  },
  name : {
    type : String,
    default : "hello"
  },
  showDone : {
    type : Boolean,
    default : false
  },
  showTitleOnly : {
    type : Boolean,
    default : false
  }
})

//console.log("show done in top nav",props.showDone)
const showDone = computed({ get() {return props.showDone}})
const showTitleOnly = computed({ get() {return props.showTitleOnly}})

const doneString = ref(t("Back"))

const signinString = ref("")
const isSignon = ref(true)

const showDoneFlag = ref(props.showDone)

watch(showDone, (newVal,oldVal) => {
  //console.log('*********** changed showDone',newVal)
  showDoneFlag.value = newVal
})

function menuClick(label) {
  //("************************ MENU ",label)
  emit("menu-click",label)

}
</script>

<style scoped>

</style>
